<main>
  <header>
    <h1>Where is your business located?</h1>
    <h2>Please provide the complete address of your business. Ensure this information is accurate, as it will be used for official correspondence and verification. P.O. Boxes are not allowed.</h2>
  </header>

  <form class="application-form" [formGroup]="form" (ngSubmit)="continue()" appPopulateForm [formType]="'businessLocation'" [form]="form">
    <mat-checkbox class="same-address-checkbox" (change)="onSameAddressChange($event)">
      My business' physical address is the same as my personal address
    </mat-checkbox>

    <!-- Street Address -->
    <div class="field">
      <label for="streetAddress">Street Address</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="streetAddress" required placeholder="Enter">
        @if (form.get('streetAddress')?.hasError('required')) {
          <mat-error>
            Street Address is required
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Suite/Unit/Office -->
    <div class="field">
      <label for="suiteUnitOffice">Suite/Unit/Office</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="suiteUnitOffice" placeholder="(optional)">
      </mat-form-field>
    </div>

    <!-- City -->
    <div class="field">
      <label for="city">City</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <input matInput formControlName="city" required placeholder="Enter">
        @if (form.get('city')?.hasError('required')) {
          <mat-error>
            City is required
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-row">
      <!-- State -->
      <div class="field">
        <label for="state">State</label>
        <mat-form-field appearance="outline" hideRequiredMarker>
          <mat-select formControlName="state" placeholder="Enter">
            @for (state of usStates; track state) {
              <mat-option [value]="state">{{state}}</mat-option>
            }
          </mat-select>
          @if (form.get('state')?.hasError('required')) {
            <mat-error>
              Please enter a valid state abbreviation
            </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Zip Code -->
      <div class="field">
        <label for="zipCode">Zip Code</label>
        <mat-form-field appearance="outline" hideRequiredMarker>
          <input matInput formControlName="zipCode" required type="text" maxlength="5" pattern="\d{5}" inputmode="numeric"
            (keypress)="onlyNumberKey($event)" placeholder="Enter">
          @if (form.get('zipCode')?.hasError('required')) {
            <mat-error>
              Zip Code is required
            </mat-error>
          }
          @if (form.get('zipCode')?.hasError('pattern')) {
            <mat-error>
              Zip Code must be exactly 5 digits
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <app-form-actions
      [isFormInvalid]="form.invalid"
      (continue)="continue()"
      (back)="goBack()"
      >
    </app-form-actions>
  </form>
</main>